import { EntityDetailsWrapper, MappingOverview } from 'components';
import DropInPanel from 'components/DropInPanel/DropInPanel';
import EntityJSONViewer from 'components/EntityDetails/EntityJSONViewer';
import EditMappingRelation from 'components/MappingEditor/EditMappingRelation/EditMappingRelation';
import { MappingTesting } from 'components/Mappings/MappingTesting';
import { MappingContext } from 'contexts/MappingContext';
import { CACHE_FIRST, ENTITY_PATH_ID } from 'contracts/constants';
import type { EntityTab } from 'contracts/interfaces';
import type { FC } from 'react';
import { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetMappingQuery } from 'services/graphql/generated/hooks';
import { getParams } from 'utils';

interface IMappingProps {
  locked?: boolean;
}
const Mapping: FC<IMappingProps> = ({ locked }) => {
  const ctx = useContext(MappingContext);
  const { pathname } = useLocation();
  const [renderEditor, setRenderEditor] = useState(false);
  const params: any = getParams(pathname, [ENTITY_PATH_ID]);

  const { loading: loadingMapping, data: mappingData } = useGetMappingQuery({
    variables: {
      packageVersionUuid: params.versionUuid,
      uuid: params.entityId
    },
    skip: !params.entityId,
    ...CACHE_FIRST
  });

  const loadingDiv = false;
  // const loadingDiv = loadingModel && ctx?.state.uuid ? <LoadingPlaceholder /> : null;
  const onChange = (tab: any): boolean | undefined | void => {
    // Hide editor overlay when tab not schema
    setRenderEditor(tab === 'Mapping');
  };
  const isSet = (value: any): boolean => value !== undefined && value != null;
  const tabs: EntityTab[] = [
    {
      label: 'Overview',
      isActive: true,
      content: loadingDiv || (
        <MappingOverview
          key={`${params.versionUuid},${params.entityId}_Overview`}
          params={params}
          isEditable={locked !== true}
        />
      )
    },
    {
      label: 'JSON',
      content: loadingDiv || (
        <EntityJSONViewer
          key={`${params.versionUuid},${params.entityId}_JSON`}
          name={mappingData?.getMapping.name || ''}
          description={mappingData?.getMapping.description || ''}
          data={mappingData?.getMapping.schema}
        />
      )
    },
    {
      label: 'Testing',
      content: (
        <MappingTesting
          mapping={mappingData?.getMapping.schema || undefined}
          mappingUuid={mappingData?.getMapping.uuid}
          packageVersionUuid={params.versionUuid}
        />
      )
    }
  ];

  return (
    <>
      <EntityDetailsWrapper tabs={tabs} onChange={onChange} />
      <DropInPanel isHidden={!renderEditor} displayFn={() => isSet(ctx?.state.selected)}>
        <EditMappingRelation locked={locked} />
      </DropInPanel>
    </>
  );
};

export default Mapping;
